import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import { MAX_OBJECTS_PER_REQUEST, fqsRequestAll } from '@ctw/shared/api/fqs/client';
import {
  type ServiceRequestGraphqlResponse,
  ServiceRequestQuery,
} from '@ctw/shared/api/fqs/queries/service-requests';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import type { GraphQLClient } from 'graphql-request';

export async function fetchServiceRequests(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  patient: PatientModel,
) {
  const { data } = await fqsRequestAll<ServiceRequestGraphqlResponse>(
    telemetry,
    graphqlClient,
    ServiceRequestQuery,
    'ServiceRequestConnection',
    {
      upid: patient.UPID,
      cursor: '',
      first: MAX_OBJECTS_PER_REQUEST,
    },
  );

  return data.ServiceRequestConnection.edges.map(({ node }) => node);
}
